import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base-component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { appInjector } from '../app-injector';
import { PackageInfo } from '../comun/recipient-services/package-info';
import { ExpeditionsService } from '../services/expeditions.service';
import { ErrorModalComponent } from '../error-modal/error-modal.component';

@Component({
  selector: 'app-package-tracking-modal',
  templateUrl: './package-tracking-modal.component.html',
  styleUrls: ['./package-tracking-modal.component.css']
})
export class PackageTrackingModalComponent extends BaseComponent {
  packageInfo: PackageInfo;
  constructor(public modalRef: BsModalRef) {
    super();
  }

  static async show(packageInfo: PackageInfo) {
    if (!packageInfo.Tracking) {
      const service: ExpeditionsService = appInjector.get(ExpeditionsService);
      try {
        packageInfo.Tracking = await service.tracking(packageInfo.LicensePlate).toPromise();
      } catch (ex) {
        ErrorModalComponent.show(ex);
        return;
      }

    }
    const modalService = appInjector.get(BsModalService);

    modalService.show(PackageTrackingModalComponent, {
      initialState: {
        packageInfo: packageInfo
      }, class: 'modal-bulto'
    });
  }
}
